function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/**
 * @license Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
import { Plugin } from '@ckeditor/ckeditor5-core/dist/index.js';
import { FileRepository } from '@ckeditor/ckeditor5-upload/dist/index.js';
/**
 * @license Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/* globals window, document */

/**
* @module adapter-ckfinder/utils
*/

var TOKEN_COOKIE_NAME = 'ckCsrfToken';
var TOKEN_LENGTH = 40;
var tokenCharset = 'abcdefghijklmnopqrstuvwxyz0123456789';
/**
 * Returns the CSRF token value. The value is a hash stored in `document.cookie`
 * under the `ckCsrfToken` key. The CSRF token can be used to secure the communication
 * between the web browser and the CKFinder server.
 */

function getCsrfToken() {
  var token = getCookie(TOKEN_COOKIE_NAME);

  if (!token || token.length != TOKEN_LENGTH) {
    token = generateToken(TOKEN_LENGTH);
    setCookie(TOKEN_COOKIE_NAME, token);
  }

  return token;
}
/**
 * Returns the value of the cookie with a given name or `null` if the cookie is not found.
 */


function getCookie(name) {
  name = name.toLowerCase();
  var parts = document.cookie.split(';');

  var _iterator = _createForOfIteratorHelper(parts),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var part = _step.value;
      var pair = part.split('=');
      var key = decodeURIComponent(pair[0].trim().toLowerCase());

      if (key === name) {
        return decodeURIComponent(pair[1]);
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return null;
}
/**
 * Sets the value of the cookie with a given name.
 */


function setCookie(name, value) {
  document.cookie = encodeURIComponent(name) + '=' + encodeURIComponent(value) + ';path=/';
}
/**
 * Generates the CSRF token with the given length.
 */


function generateToken(length) {
  var result = '';
  var randValues = new Uint8Array(length);
  window.crypto.getRandomValues(randValues);

  for (var j = 0; j < randValues.length; j++) {
    var character = tokenCharset.charAt(randValues[j] % tokenCharset.length);
    result += Math.random() > 0.5 ? character.toUpperCase() : character;
  }

  return result;
}
/**
 * A plugin that enables file uploads in CKEditor 5 using the CKFinder server–side connector.
 *
 * See the {@glink features/file-management/ckfinder "CKFinder file manager integration"} guide to learn how to configure
 * and use this feature as well as find out more about the full integration with the file manager
 * provided by the {@link module:ckfinder/ckfinder~CKFinder} plugin.
 *
 * Check out the {@glink features/images/image-upload/image-upload comprehensive "Image upload overview"} guide to learn
 * about other ways to upload images into CKEditor 5.
 */


var CKFinderUploadAdapter = /*#__PURE__*/function (_Plugin) {
  _inherits(CKFinderUploadAdapter, _Plugin);

  var _super = _createSuper(CKFinderUploadAdapter);

  function CKFinderUploadAdapter() {
    _classCallCheck(this, CKFinderUploadAdapter);

    return _super.apply(this, arguments);
  }

  _createClass(CKFinderUploadAdapter, [{
    key: "init",
    value:
    /**
    * @inheritDoc
    */
    function init() {
      var _this = this;

      var url = this.editor.config.get('ckfinder.uploadUrl');

      if (!url) {
        return;
      } // Register CKFinderAdapter


      this.editor.plugins.get(FileRepository).createUploadAdapter = function (loader) {
        return new UploadAdapter(loader, url, _this.editor.t);
      };
    }
  }], [{
    key: "requires",
    get:
    /**
    * @inheritDoc
    */
    function get() {
      return [FileRepository];
    }
    /**
    * @inheritDoc
    */

  }, {
    key: "pluginName",
    get: function get() {
      return 'CKFinderUploadAdapter';
    }
  }]);

  return CKFinderUploadAdapter;
}(Plugin);
/**
 * Upload adapter for CKFinder.
 */


var UploadAdapter = /*#__PURE__*/function () {
  /**
  * FileLoader instance to use during the upload.
  */

  /**
  * Upload URL.
  */

  /**
  * Locale translation method.
  */

  /**
  * Creates a new adapter instance.
  */
  function UploadAdapter(loader, url, t) {
    _classCallCheck(this, UploadAdapter);

    this.loader = void 0;
    this.url = void 0;
    this.t = void 0;
    this.xhr = void 0;
    this.loader = loader;
    this.url = url;
    this.t = t;
  }
  /**
  * Starts the upload process.
  *
  * @see module:upload/filerepository~UploadAdapter#upload
  */


  _createClass(UploadAdapter, [{
    key: "upload",
    value: function upload() {
      var _this2 = this;

      return this.loader.file.then(function (file) {
        return new Promise(function (resolve, reject) {
          _this2._initRequest();

          _this2._initListeners(resolve, reject, file);

          _this2._sendRequest(file);
        });
      });
    }
    /**
    * Aborts the upload process.
    *
    * @see module:upload/filerepository~UploadAdapter#abort
    */

  }, {
    key: "abort",
    value: function abort() {
      if (this.xhr) {
        this.xhr.abort();
      }
    }
    /**
    * Initializes the XMLHttpRequest object.
    */

  }, {
    key: "_initRequest",
    value: function _initRequest() {
      var xhr = this.xhr = new XMLHttpRequest();
      xhr.open('POST', this.url, true);
      xhr.responseType = 'json';
    }
    /**
    * Initializes XMLHttpRequest listeners.
    *
    * @param resolve Callback function to be called when the request is successful.
    * @param reject Callback function to be called when the request cannot be completed.
    * @param file File instance to be uploaded.
    */

  }, {
    key: "_initListeners",
    value: function _initListeners(resolve, reject, file) {
      var xhr = this.xhr;
      var loader = this.loader;
      var t = this.t;
      var genericError = t('Cannot upload file:') + " ".concat(file.name, ".");
      xhr.addEventListener('error', function () {
        return reject(genericError);
      });
      xhr.addEventListener('abort', function () {
        return reject();
      });
      xhr.addEventListener('load', function () {
        var response = xhr.response;

        if (!response || !response.uploaded) {
          return reject(response && response.error && response.error.message ? response.error.message : genericError);
        }

        resolve({
          default: response.url
        });
      }); // Upload progress when it's supported.

      /* istanbul ignore else -- @preserve */

      if (xhr.upload) {
        xhr.upload.addEventListener('progress', function (evt) {
          if (evt.lengthComputable) {
            loader.uploadTotal = evt.total;
            loader.uploaded = evt.loaded;
          }
        });
      }
    }
    /**
    * Prepares the data and sends the request.
    *
    * @param file File instance to be uploaded.
    */

  }, {
    key: "_sendRequest",
    value: function _sendRequest(file) {
      // Prepare form data.
      var data = new FormData();
      data.append('upload', file);
      data.append('ckCsrfToken', getCsrfToken()); // Send request.

      this.xhr.send(data);
    }
  }]);

  return UploadAdapter;
}();

export { CKFinderUploadAdapter };